export default "__VITE_ASSET__DrjBg6SP__"